import React, { useCallback, useEffect, useRef } from 'react'
import Link from 'next/link'
import { getNome } from '../../../services/auth'
import Busca from '../../pesquisa'
import Carrinho from '../../carrinho'
import Favorito from '../../favorito'
import { ThumborLoader } from '../../../util/thumborLoader'
import InformeCep from '../../informeCep'
import InformaCepMobile from '../../informaCepMobile'
import { IconPhone } from '../icons/phone'
import { IconPackage } from '../icons/package'
import { IconNewUser } from '../icons/user'
import { ContactArea, Container } from '../styles'
import Image from 'next/image'
import { IconLogoGazin } from '@gazin/ecommerce-ui'

export function HeaderDesktop({
  ImageTheo,
  logado,
  textColor,
  showZipcodeBox,
  setShowZipcodeBox,
  activeDropdownUser,
  hideDropdownUser,
  sair,
  isMobile,
  buttonColor,
  buttonCartTextColor,
}) {
  const handleOnContactAreaClick = () => {
    document.querySelector('#footer').scrollIntoView({
      behavior: 'smooth',
    })
    window.addEventListener(
      'hashchange',
      () => window.history.pushState({}, '', '/'),
      {}
    )
  }

  const isOpenRef = useRef(false)

  const toggleIsOpen = useCallback(() => {
    isOpenRef.current = !isOpenRef.current
  }, [isOpenRef])

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (isOpenRef.current) {
        activeDropdownUser(event)
        toggleIsOpen()
      }
    }
    document.addEventListener('click', handleOutsideClick)

    return () => document.removeEventListener('click', handleOutsideClick)
  }, [activeDropdownUser, isOpenRef, toggleIsOpen])

  return (
    <Container>
      <Link href="/" as="/" shallow prefetch={false}>
        <Image
          src={ThumborLoader({
            src: ImageTheo,
            width: 190,
          })}
          width="190"
          height="114"
          className="theo"
          alt="Busto do Theo"
          priority
        />
      </Link>
      <div className="right">
        <div className="top">
          <p className="welcome">
            Olá! <strong>Sou o Téo da Gazin, seja bem-vindo!</strong>
          </p>
          <ul>
            <li>
              <ContactArea onClick={handleOnContactAreaClick}>
                <IconPhone size="14" color={textColor} />
                <div className="area-user">
                  <p>Contatos</p>
                </div>
              </ContactArea>
            </li>
            <li>
              <Link
                href={logado ? '/conta/pedidos' : '/login'}
                as={logado ? '/conta/pedidos' : '/login'}
                shallow
                prefetch={false}
              >
                <IconPackage size="14" color={textColor} />
                <span className="link-pedidos">Meus pedidos</span>
              </Link>
            </li>
            <li>
              <Link
                href="https://areadocliente.gazin.com.br/login.php"
                target="_blank"
                rel="noopener noreferrer"
                className="parcela-loja"
              >
                Pague sua parcela da loja
              </Link>
            </li>
            {!isMobile && (
              <li>
                <InformeCep
                  isActive={showZipcodeBox}
                  setIsActive={setShowZipcodeBox}
                  textColor={textColor}
                />
              </li>
            )}
          </ul>
        </div>
        <div className="geral">
          <div className="logo">
            <Link
              href="/"
              as="/"
              shallow
              prefetch={false}
              aria-label="Logo Gazin"
            >
              {isMobile ? (
                <IconLogoGazin
                  height="3.5rem"
                  width="11.75rem"
                  maxWidth="100%"
                />
              ) : (
                <IconLogoGazin
                  height="3.6rem"
                  width="11.75rem"
                  maxWidth="100%"
                  marginTop="0.7em"
                />
              )}
            </Link>
          </div>
          <Busca />
          {isMobile && (
            <InformaCepMobile
              isActive={showZipcodeBox}
              setIsActive={setShowZipcodeBox}
            />
          )}
          <div className="area-user" onClick={(e) => e.stopPropagation()}>
            <button
              className="btn-user"
              onClick={(e) => {
                activeDropdownUser(e)
                toggleIsOpen()
              }}
              aria-label="Usuário"
            >
              <IconNewUser size="24" color={textColor} />

              <div className="info-user">
                <span>Olá! 😄</span>
                {!logado ? (
                  <p>Entre ou cadastre-se</p>
                ) : (
                  <p>{`${getNome().split(' ')[0]}`}</p>
                )}
              </div>
            </button>
            <div
              className="dropdown-cadastro"
              onMouseLeave={() => hideDropdownUser()}
            >
              <Link
                href={logado ? '/conta' : '/login'}
                as={logado ? '/conta' : '/login'}
                shallow
                prefetch={false}
                className="btn-entrar"
              >
                {logado ? 'Minha Conta' : 'entrar'}
              </Link>

              {!logado ? (
                <Link
                  href="/cadastro"
                  as="/cadastro"
                  shallow
                  prefetch={false}
                  className="btn-cadastro"
                >
                  Novo aqui? Cadastre-se
                </Link>
              ) : (
                <Link
                  href="/"
                  as="/"
                  shallow
                  prefetch={false}
                  className="btn-cadastro"
                  onClick={(e) => sair(e)}
                >
                  Sair
                </Link>
              )}
              <ul>
                <li>
                  <Link
                    href={logado ? '/conta' : '/login'}
                    as={logado ? '/conta' : '/login'}
                    shallow
                    prefetch={false}
                  >
                    Minha conta
                  </Link>
                </li>
                <li>
                  <Link
                    href={logado ? '/conta/pedidos' : '/login'}
                    as={logado ? '/conta/pedidos' : '/login'}
                    shallow
                    prefetch={false}
                  >
                    Meus pedidos
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <Favorito textColor={textColor} backgroundColor={buttonColor} />
          <Carrinho
            textColor={textColor}
            buttonCartTextColor={buttonCartTextColor}
          />
        </div>
      </div>
      <Link
        href="https://areadocliente.gazin.com.br/login.php"
        target="_blank"
        rel="noopener noreferrer"
        className="parcela-loja"
      >
        <div className="box-parcela-loja">Pague sua parcela da loja</div>
      </Link>
    </Container>
  )
}
